import * as angular from 'angular';

import { SchedulesModalService } from './schedules-modal.service';

export const SchedulesModalDirective = function (schedulesModalService: SchedulesModalService) {
  return {
    restrict: 'A',
    scope: {
      report: '<',
      reportRun: '<',
      owner: '<',
      account: '<',
      view: '@?',
      schedule: '<?',
      onSchedulesUpdate: '&?',
    },
    link: function ($scope: angular.IScope, elem: angular.IAugmentedJQuery, attrs: angular.IAttributes) {
      elem.on('click.schedulesModal', (event) => {
        schedulesModalService.open({
          report: $scope['report'],
          run: $scope['reportRun'],
          reportOwner: $scope['owner'],
          account: $scope['account'],
          view: $scope['view'],
          schedule: $scope['schedule'],
          onSchedulesUpdate: $scope['onSchedulesUpdate'],
        });
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.schedulesModal'));
    },
  };
};

SchedulesModalDirective.$inject = ['SchedulesModalService'];
